<template>
    <div class="page-box">
        <h2 class="page-box-title">关于我们</h2>
        <div class="page-box-content">
            <p>
                启帆数字，致力于提供优质的科技供应链服务。公司以平台模式和增量共赢思维，
                赋予商业场景整体生态链能力，打造交易生态领域的管家制智能服务平台，并希望成为中国品牌商家的重要合作伙伴。
            </p>
            <p>
                团队核心人员由原阿里巴巴团队、美国虹软Arcsoft技术团队、明星C轮公司开始吧 核心高管层组成，曾全面负责营销、产品、技术、
                运营、客服售后等核心板块，管理班底历经2家头部企业创业的洗礼。
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'About'
};
</script>

<style scoped></style>
